module.exports = __webpack_public_path__ + "static-portal/img/10.bf7f8a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.jpg
// module id = TV5D
// module chunks = 4